/**
 * Text — Themed typography element
 *
 * Variants:
 *   - preset: h1, h2, h3, body, bodySmall, caption, label
 *   - tone: default, secondary, muted, inverse, error, success
 */
import { styled, Text as TamaguiText } from 'tamagui'

export const Text = styled(TamaguiText, {
  name: 'Text',
  fontFamily: '$body',
  color: '$color',

  variants: {
    preset: {
      display: {
        fontFamily: '$cursive',
        fontSize: 30,
        lineHeight: 36,
        letterSpacing: -0.5,
      },
      h1: {
        fontFamily: '$cursive',
        fontSize: '$6',
        lineHeight: '$6',
      },
      h2: {
        fontFamily: '$cursive',
        fontSize: '$5',
        lineHeight: '$5',
      },
      h3: {
        fontFamily: '$cursive',
        fontSize: '$4',
        lineHeight: '$4',
      },
      body: {
        fontSize: '$4',
        lineHeight: '$4',
        fontWeight: '400',
      },
      bodySmall: {
        fontSize: '$3',
        lineHeight: '$3',
        fontWeight: '400',
      },
      caption: {
        fontSize: '$2',
        lineHeight: '$2',
        fontWeight: '500',
      },
      label: {
        fontSize: '$3',
        lineHeight: '$3',
        fontWeight: '600',
      },
      button: {
        fontSize: '$4',
        lineHeight: '$4',
        fontWeight: '600',
      },
    },

    tone: {
      default: { color: '$color' },
      secondary: { color: '$colorSecondary' },
      muted: { color: '$colorMuted' },
      inverse: { color: '$colorInverse' },
      error: { color: '$colorError' },
      success: { color: '$colorSuccess' },
      primary: { color: '$colorPrimary' },
    },

    align: {
      left: { textAlign: 'left' },
      center: { textAlign: 'center' },
      right: { textAlign: 'right' },
    },
  } as const,

  defaultVariants: {
    preset: 'body',
    tone: 'default',
  },
})
